import { render } from "./DirectoryDrawer.vue?vue&type=template&id=444aff12&scoped=true"
import script from "./DirectoryDrawer.vue?vue&type=script&lang=js"
export * from "./DirectoryDrawer.vue?vue&type=script&lang=js"

import "./DirectoryDrawer.vue?vue&type=style&index=0&id=444aff12&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444aff12"]])

export default __exports__